<template>
  <el-container class="content-width" style="flex-direction: column">
    <div-unit unitTitle="Content us" v-loading="loading">

      <div v-if="finish_prompt != ''" class="finish_prompt">
        {{ finish_prompt }}
      </div>
      <div class="contact-text">
        Please contact us for feedback, suggestions, or to report errors or
        bugs.
      </div>
      <br />
      <el-form
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <div style="display: flex; justify-content: space-between">
          <el-form-item label="First Name" prop="firstName" placeholder="First name" style="width: 48%">
            <el-input v-model="ruleForm.firstName"></el-input>
          </el-form-item>
          <el-form-item label="Last Name" prop="lastName" placeholder="Last name" style="width: 48%">
            <el-input v-model="ruleForm.lastName"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex; justify-content: space-between" placeholder="Email Address">
          <el-form-item label="Email" prop="email" style="width: 48%">
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item>
          <el-form-item label="Topic" prop="topic" style="width: 48%">
            <el-select
              v-model="ruleForm.topic"
              placeholder="Please select one topic"
              style="width: 100%"
            >
              <el-option
                label="Report a Bug/Error"
                value="Report a Bug/Error"
              ></el-option>
              <el-option
                label="Request a Feature"
                value="Request a Feature"
              ></el-option>
              <el-option
                label="Send a Suggestion"
                value="Send a Suggestion"
              ></el-option>
              <el-option label="Other" value="Other"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="Message" prop="messages" placeholder="Your message...">
          <el-input
            type="textarea"
            v-model="ruleForm.messages"
            rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item class="button-align">
          <el-button
            class="btn-submit"
            @click="submitForm('ruleForm')"
            style="font-size: 22px"
            >Submit</el-button
          >
          <el-button
            class="btn-submit"
            @click="resetForm('ruleForm')"
            style="font-size: 22px"
            >Reset</el-button
          >
        </el-form-item>
      </el-form>
    </div-unit>
  </el-container>
</template>




<script>
import DivUnit from "@/components/DivUnit.vue";
import api from "../api/index";
// import qs from "qs"

export default {
  components: {
    DivUnit,
  },
  data() {
    return {
      loading: false,
      finish_prompt: "",
      ruleForm: {
        firstName: "",
        lastName: "",
        email: "",
        topic: "",
        messages: "",
      },
      rules: {
        firstName: [
          {
            required: true,
            message: "Please enter the first name",
            trigger: "blur",
          },
        ],
        lastName: [
          {
            required: true,
            message: "Please enter the last name",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "Please enter the email",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter the correct email",
            trigger: ["blur", "change"],
          },
        ],
        topic: [
          {
            required: true,
            message: "Please enter the first name",
            trigger: "change",
          },
        ],
        messages: [
          {
            required: true,
            message: "Please fill in the message to be sent",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          api.postContactUs(this.ruleForm).then((res) => {
            console.log(res.data);
            this.$refs[formName].resetFields();
            this.loading = false;
            this.finish_prompt = res.data.result;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style>

.input_example {
  color: #ff9800;
  cursor: pointer;
}
.input_example:hover {
  text-decoration: underline;
}
.input-title {
  font-size: 22px;
  font-weight: bold;
  color: #5181c6;
  margin-top: 20px;
}
.el-form-item__label {
  font-size: 22px;
  font-weight: bold;
  color: #5181c6;
}
.el-tabs__item {
  font-size: 22px;
  font-weight: bold;
}
.el-tabs__item.is-active,
.el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #ed862a;
}
.el-tabs__active-bar {
  background-color: #ed862a;
  height: 3px;
}
.el-tabs__nav-scroll {
  display: flex;
  justify-content: space-around;
}
.el-tabs__nav-wrap::after {
  width: auto;
}
.contact-text {
  margin-bottom: 30px;
  padding: 16px;

  border-radius: 10px;
  font-size: 24px;
  text-align: center;
  font-weight: bold;
}
.btn-submit {
  font-size: 20px;
  background: #5181c6;
  color: #fff;
}
.btn-submit:hover,
.btn-submit:active,
.btn-submit:focus {
  background: #6699e0;
  color: #fff;
}
.btn-submit2 {
  font-size: 20px;
  background: #ed862a;
  color: #fff;
}
.btn-submit2:hover,
.btn-submit2:active,
.btn-submit2:focus {
  background: #dd8e48;
  color: #fff;
}
.el-upload-list {
  width: 50%;
}
.button-align {
  display: flex;
  justify-content: space-around;
  margin-top: 50px;
}
.el-notification {
  width: 400px;
  background: #ffeaa5;
}
.el-message-box__title {
  font-size: 20px;
  font-weight: bold;
}
.el-form-item__error {
  font-size: 18px;
}
.finish_prompt {
  color: #f56c6c;
    padding: 12px;
    border-radius: 4px;
    border: 1px solid #f56c6c;
    font-size: 18px;
}
</style>